import React from 'react'
export type ShortlistContextType = {
  shortlistId: string | null | undefined
}
export const ShortlistContext: React.Context<ShortlistContextType> =
  React.createContext<ShortlistContextType>({
    shortlistId: null,
  })
type Props = {
  children: React.ReactNode
  value: ShortlistContextType
}
export const ShortlistProvider = ({
  children,
  value,
}: Props): React.ReactNode => {
  return (
    <ShortlistContext.Provider value={value}>
      {children}
    </ShortlistContext.Provider>
  )
}
